"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var addressRegex = /^0x[a-fA-F0-9]{40}$/; // eslint-disable-next-line no-unused-vars

function buildSubGraphWrapper(campaignWeb3, users, edges) {
  var refMapNodeCounter = {
    counter: 0
  };
  var paidClicksDownstream = {
    counter: 0
  };
  var unpaidClicksDownstream = {
    counter: 0
  };
  var conversionsDownstream = {
    counter: 0
  };
  var referrers = {
    counter: 0
  };
  var rejectedConversions = {
    counter: 0
  };
  var hoverByPlasma = {};
  var maxChainLength = {
    counter: 0
  };

  function buildSubGraph(startingNode, depth) {
    var vertex = {};
    var childrenArr = [];
    vertex.contractAddress = campaignWeb3; // vertex.isJoined = revJoins[startingNode] !== undefined || startingNode === contractorPlasma;

    if (users[startingNode]) {
      vertex.userCreation = users[startingNode].userCreationTimestamp;
      vertex.email = users[startingNode].userRegInfo._email;
      vertex.userJoinCampaignTimestamp = users[startingNode].userJoinCampaignTimestamp;
      vertex.walletName = users[startingNode].userRegInfo._walletName;
      vertex.fullName = users[startingNode].userRegInfo._fullName || vertex.username;
      vertex.tokensBought = users[startingNode].tokensBought;
      vertex.conversionTimestamp = users[startingNode].conversionTimestamp;
      vertex.username = users[startingNode].userRegInfo._handle != null ? users[startingNode].userRegInfo._handle : null;
      vertex.referrerRewards = users[startingNode].reward > 0 ? users[startingNode].reward : 0;
      vertex.amountConverterSpentETH = users[startingNode].conversionEthAmount;
      vertex.amountConverterSpentFIAT = users[startingNode].amountConverterSpentFIAT;
      vertex.lastRewardTimestamp = users[startingNode].lastRewardTimestamp;
      vertex.paid = users[startingNode].paid;
      var isConverter = false;
      vertex.conversions = users[startingNode].conversions;

      if (vertex.conversions) {
        var conversionState;
        var conversionRejectedReason;

        for (var _i = 0, _Object$entries = Object.entries(users[startingNode].statusByConversions); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              conversionId = _Object$entries$_i[0],
              conStatus = _Object$entries$_i[1];

          if (conStatus.status == 'EXECUTED') {
            vertex.isConverter = true;
            conversionState = 'Executed';
            conversionRejectedReason = undefined;
          } else if (conStatus.status == 'APPROVED' && conStatus.status != 'EXECUTED') {
            vertex.isConverter = true;
            conversionState = 'Approved';
            conversionRejectedReason = undefined;
          } else if (conStatus.status == 'REJECTED' && !['EXECUTED', 'APPROVED'].includes(conStatus.status)) {
            conversionState = 'Rejected';
            vertex.isRejected = true;
            conversionRejectedReason = conStatus.rejectedStatusCode;
          }
        }

        vertex.converterRejectionReason = conversionRejectedReason;
        vertex.converterState = conversionState;
      }
    }

    vertex.plasmaAddress = startingNode;
    vertex.depth = depth;
    maxChainLength.counter = depth > maxChainLength.counter ? depth : maxChainLength.counter;
    vertex.paidClicksDownstream = 0;
    vertex.referrersDownstream = 0;
    vertex.unpaidClicksDownstream = 0;
    vertex.conversionsDownstream = 0;
    vertex.visitsDownstream = 0;
    vertex.paidClicksAfterMe = 0;
    vertex.unpaidClicksAfterMe = 0;
    vertex.conversionsAfterMe = 0;
    vertex.visitsAfterMe = 0;
    vertex.rejectedConversionsAfterMe = 0;
    vertex.rejectedConversionsDownstream = 0;
    vertex.statistics = {
      amountConverterSpentETH: vertex.amountConverterSpentETH,
      referrerRewards: vertex.referrerRewards,
      isConverter: vertex.isConverter,
      isReferrer: vertex.isReferrer // isJoined: vertex.isJoined,

    };
    var tokenBoughtTempHolder = 0;
    var ethSpentTempHolder = 0; // let fiatSpentTempHolder = 0;

    var subgraphPaid;
    var subgraphReferred;
    var subgraphUnPaid;
    var subgraphConverted;
    var subgraphVisited;
    var subgraphRejected;

    if (edges[startingNode] != null) {
      edges[startingNode].forEach(function (node) {
        var subgraph = buildSubGraph(node, depth + 1);
        tokenBoughtTempHolder += subgraph.totalTokensBoughtSubgraph;
        ethSpentTempHolder += subgraph.totalETHSpentSubgraph;
        subgraphPaid = subgraph.paid == true ? 1 : 0;
        subgraphUnPaid = subgraph.paid == false ? 1 : 0;
        subgraphConverted = subgraph.conversions ? 1 : 0;
        subgraphVisited = 1;
        subgraphRejected = subgraph.isRejected ? 1 : 0;
        subgraphReferred = subgraph.isReferrer ? 1 : 0;
        vertex.paidClicksDownstream += subgraph.paidClicksDownstream + subgraphPaid;
        vertex.referrersDownstream += subgraph.referrersDownstream + subgraphReferred;
        vertex.unpaidClicksDownstream += subgraph.unpaidClicksDownstream + subgraphUnPaid;
        vertex.conversionsDownstream += subgraph.conversionsDownstream + subgraphConverted;
        vertex.visitsDownstream += subgraph.visitsDownstream + subgraphVisited;
        vertex.rejectedConversionsDownstream += subgraph.rejectedConversionsDownstream + subgraphRejected;
        vertex.paidClicksAfterMe += subgraphPaid;
        vertex.unpaidClicksAfterMe += subgraphUnPaid;
        vertex.conversionsAfterMe += subgraphConverted;
        vertex.visitsAfterMe += subgraphVisited;
        vertex.rejectedConversionsAfterMe += subgraphRejected;
        childrenArr.push(subgraph);
      });
      vertex.children = childrenArr;
    }

    paidClicksDownstream.counter = vertex.paidClicksDownstream;
    unpaidClicksDownstream.counter = vertex.unpaidClicksDownstream;
    vertex.isReferrer = vertex.children ? true : false;
    vertex.linkClassName = (vertex.converterRejectionReason || vertex.isRejected) && 'leaf-converter-rejected' || (childrenArr.length || vertex.isReferrer) && 'leaf-referrer' || vertex.paid && 'leaf-converter-paid' || vertex.isConverter && 'leaf-converter' || vertex.username && 'leaf-plasma';
    vertex.name = (vertex.username != null && vertex.username.length > 10 ? "".concat(vertex.username.substring(0, 10), "...") : vertex.username) || users[startingNode] && users[startingNode].userRegInfo._handle || startingNode;
    vertex.name = addressRegex.test(vertex.name) ? vertex.name.replace(/^(0x.{5}).{31}/, '$1...') : vertex.name;
    hoverByPlasma[vertex.plasmaAddress] = {
      address: startingNode,
      amountConverterSpentETH: vertex.amountConverterSpentETH,
      email: vertex.email,
      fullName: vertex.fullName,
      name: vertex.name,
      isConverter: vertex.isConverter,
      isReferrer: vertex.isReferrer,
      // isJoined: vertex.isJoined,
      rewards: vertex.referrerRewards,
      tokensBought: vertex.tokensBought,
      timestamp: new Date(vertex.userJoinCampaignTimestamp * 1000) || Date.now(),
      handle: vertex.username,
      referrerLastActivity: vertex.lastRewardTimestamp,
      amountConverterSpentFIAT: vertex.amountConverterSpentFIAT,
      conversionTimestamp: vertex.conversionTimestamp,
      paid: vertex.paid,
      conversionRejectedReason: vertex.converterRejectionReason,
      converterRejectionReason: vertex.converterRejectionReason,
      conversionState: vertex.converterState,
      conversions: vertex.conversions,
      conversionsDownstream: vertex.conversionsDownstream,
      visitsDownstream: vertex.visitsDownstream,
      paidClicksAfterMe: vertex.paidClicksAfterMe,
      unpaidClicksAfterMe: vertex.unpaidClicksAfterMe,
      approvedClicksAfterMe: vertex.paidClicksAfterMe + vertex.unpaidClicksAfterMe,
      conversionsAfterMe: vertex.conversionsAfterMe,
      visitsAfterMe: vertex.visitsAfterMe,
      paidClicksDownstream: vertex.paidClicksDownstream,
      unpaidClicksDownstream: vertex.unpaidClicksDownstream,
      approvedClicksDownstream: vertex.paidClicksDownstream + vertex.unpaidClicksDownstream,
      rejectedConversionsAfterMe: vertex.rejectedConversionsAfterMe,
      rejectedConversionsDownstream: vertex.rejectedConversionsDownstream,
      referrersDownstream: vertex.referrersDownstream
    };
    vertex.totalTokensBoughtSubgraph = tokenBoughtTempHolder + vertex.tokensBought;
    vertex.totalETHSpentSubgraph = ethSpentTempHolder + vertex.amountConverterSpentETH;
    vertex.nodeSvgShape = {
      links: {
        display: 'none'
      },
      shape: 'circle',
      shapeProps: {
        r: 10,
        strokeWidth: 3,
        stroke: (vertex.converterRejectionReason || vertex.isRejected) && 'red' || (childrenArr.length || vertex.isReferrer) && (vertex.isConverter ? 'magenta' : 'darkviolet') || vertex.paid && '#8aff3d' || vertex.isConverter && '#45a307' || (vertex.isConverter || vertex.referrerRewards) && '#45a307' || vertex.username && 'orange' || '#999'
      }
    };
    referrers.counter += vertex.isReferrer ? 1 : 0;
    refMapNodeCounter.counter += 1;
    rejectedConversions.counter = vertex.rejectedConversionsDownstream;
    conversionsDownstream.counter = vertex.conversionsDownstream;
    return vertex;
  }

  return [buildSubGraph, hoverByPlasma, {
    refMapNodeCounter: refMapNodeCounter,
    paidClicksDownstream: paidClicksDownstream,
    unpaidClicksDownstream: unpaidClicksDownstream,
    referrers: referrers,
    rejectedConversions: rejectedConversions,
    maxChainLength: maxChainLength,
    conversionsDownstream: conversionsDownstream
  }];
}

module.exports.buildSubGraphWrapper = buildSubGraphWrapper;